
import { Swiper } from "swiper";
import axios from "axios";

export default {
    name: "PopularMoive",
    data() {
        return {
            swiper: '',
            nullImage: 'https://fakeimg.pl/170x230/?text=null',
            moviePopularList: []
        }
    },
    async fetch() {
        await this.getMoviePopularList();
    },
    methods: {
        setSwiper () {
            this.swiper = new Swiper('#movie__popular__swiper', {
                direction: 'horizontal',
                observer: true,
                slidesPerView: 2.6,
                spaceBetween: 8.8,
                breakpoints: {
                    767: {
                        slidesPerView: 5.3,
                        spaceBetween: 12
                    },
                    1024: {
                        slidesPerView: 7.3,
                        spaceBetween: 12
                    }
                }
            });
        },
        async getMoviePopularList () {
            try {
                let res = await axios.get('https://www.pixnet.net/mainpage/api/channel/getMovies');
                this.moviePopularList = res.data.data.movies;
            }
            catch(error) {
                console.log('電影頻道電影排名API異常');
                console.log(error);
            }
        }
    },
    mounted() {
        this.setSwiper();
    }
}

